import Date                           from "../../../domain/fundamentals/date/Date";
import Time                           from "../../../domain/fundamentals/date/Time";
import ReservationBusinessDayType     from "../../../domain/reservation/ReservationBusinessDayType";
import ReservationSetting             from "../../../domain/reservation/ReservationSetting";
import ReservationSpecialBusinessTime from "../../../domain/reservation/ReservationSpecialBusinessTime";
import ReservationTimeType            from "../../../domain/reservation/ReservationTimeType";
import ReservationWeekType            from "../../../domain/reservation/ReservationWeekType";
import ResKaReduxAction               from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_RESERVATION_SETTING = "SET_RESERVATION_SETTING",
  ON_CHANGE_BUSINESS_TIME_TYPE = "ON_CHANGE_BUSINESS_TIME_TYPE",
  ON_CHANGE_BUSINESS_DAY_TYPE = "ON_CHANGE_BUSINESS_DAY_TYPE",
  ON_CHANGE_BUSINESS_TIME_FROM = "ON_CHANGE_BUSINESS_TIME_FROM",
  ON_CHANGE_BUSINESS_TIME_TO = "ON_CHANGE_BUSINESS_TIME_TO",
  ADD_SPECIAL_BUSINESS_TIME = "ADD_SPECIAL_BUSINESS_TIME",
  DELETE_SPECIAL_BUSINESS_TIME = "DELETE_SPECIAL_BUSINESS_TIME",
  ON_CHANGE_SPECIAL_BUSINESS_DAY_TYPE = "ON_CHANGE_SPECIAL_BUSINESS_DAY_TYPE",
  ON_CHANGE_SPECIAL_BUSINESS_DATE = "ON_CHANGE_SPECIAL_BUSINESS_DATE",
  ON_CHANGE_SPECIAL_BUSINESS_TIME_FROM = "ON_CHANGE_SPECIAL_BUSINESS_TIME_FROM",
  ON_CHANGE_SPECIAL_BUSINESS_TIME_TO = "ON_CHANGE_SPECIAL_BUSINESS_TIME_TO",
}

export interface ReservationSettingSetAction extends ResKaReduxAction {
  reservationSetting: ReservationSetting;
}

export interface BusinessTimeTypeSetAction extends ResKaReduxAction {
  timeType: ReservationTimeType;
}

export interface BusinessDayTypeSetAction extends ResKaReduxAction {
  weekType: ReservationWeekType;
  dayType: ReservationBusinessDayType;
}

export interface BusinessTimeFromSetAction extends ResKaReduxAction {
  weekType: ReservationWeekType;
  from: Time;
}

export interface BusinessTimeToSetAction extends ResKaReduxAction {
  weekType: ReservationWeekType;
  to: Time;
}

export interface SpecialBusinessTimeAddAction extends ResKaReduxAction {
  specialBusinessTime: ReservationSpecialBusinessTime;
}

export interface SpecialBusinessDayTypeSetAction extends ResKaReduxAction {
  index: number;
  dayType: ReservationBusinessDayType;
}

export interface SpecialBusinessDateSetAction extends ResKaReduxAction {
  index: number;
  date: Date;
}

export interface SpecialBusinessTimeFromSetAction extends ResKaReduxAction {
  index: number;
  from: Time;
}

export interface SpecialBusinessTimeToSetAction extends ResKaReduxAction {
  index: number;
  to: Time;
}

export interface SpecialBusinessTimeDeleteAction extends ResKaReduxAction {
  index: number;
}

export type ReservationSettingAction =
  ReservationSettingSetAction
  | BusinessTimeTypeSetAction
  | BusinessDayTypeSetAction
  | BusinessTimeFromSetAction
  | BusinessTimeToSetAction
  | SpecialBusinessDayTypeSetAction
  | SpecialBusinessDateSetAction
  | SpecialBusinessTimeFromSetAction
  | SpecialBusinessTimeToSetAction
  | SpecialBusinessTimeAddAction
  | SpecialBusinessTimeDeleteAction
;

export const setReservationSettingAction = (reservationSetting: ReservationSetting): ReservationSettingSetAction => ({
  type: ACTION_TYPE.SET_RESERVATION_SETTING,
  reservationSetting: reservationSetting,
});

export const onChangeBusinessTimeType = (timeType: ReservationTimeType): BusinessTimeTypeSetAction => ({
  type: ACTION_TYPE.ON_CHANGE_BUSINESS_TIME_TYPE,
  timeType: timeType,
});

export const onChangeBusinessDayType = (weekType: ReservationWeekType, dayType: ReservationBusinessDayType): BusinessDayTypeSetAction => ({
  type: ACTION_TYPE.ON_CHANGE_BUSINESS_DAY_TYPE,
  weekType: weekType,
  dayType: dayType,
});

export const onChangeBusinessTimeFrom = (weekType: ReservationWeekType, from: Time): BusinessTimeFromSetAction => ({
  type: ACTION_TYPE.ON_CHANGE_BUSINESS_TIME_FROM,
  weekType: weekType,
  from: from,
});

export const onChangeBusinessTimeTo = (weekType: ReservationWeekType, to: Time): BusinessTimeToSetAction => ({
  type: ACTION_TYPE.ON_CHANGE_BUSINESS_TIME_TO,
  weekType: weekType,
  to: to,
});

export const addSpecialBusinessTime = (specialBusinessTime: ReservationSpecialBusinessTime): SpecialBusinessTimeAddAction => ({
  type: ACTION_TYPE.ADD_SPECIAL_BUSINESS_TIME,
  specialBusinessTime: specialBusinessTime,
});

export const onChangeSpecialBusinessDayType = (index: number, dayType: ReservationBusinessDayType): SpecialBusinessDayTypeSetAction => ({
  type: ACTION_TYPE.ON_CHANGE_SPECIAL_BUSINESS_DAY_TYPE,
  index: index,
  dayType: dayType,
});

export const onChangeSpecialBusinessDate = (index: number, date: Date): SpecialBusinessDateSetAction => ({
  type: ACTION_TYPE.ON_CHANGE_SPECIAL_BUSINESS_DATE,
  index: index,
  date: date,
});

export const onChangeSpecialBusinessTimeFrom = (index: number, from: Time): SpecialBusinessTimeFromSetAction => ({
  type: ACTION_TYPE.ON_CHANGE_SPECIAL_BUSINESS_TIME_FROM,
  index: index,
  from: from,
});

export const onChangeSpecialBusinessTimeTo = (index: number, to: Time): SpecialBusinessTimeToSetAction => ({
  type: ACTION_TYPE.ON_CHANGE_SPECIAL_BUSINESS_TIME_TO,
  index: index,
  to: to,
});

export const specialBusinessTimeDelete = (index: number): SpecialBusinessTimeDeleteAction => ({
  type: ACTION_TYPE.DELETE_SPECIAL_BUSINESS_TIME,
  index: index,
});